/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsFinanceRequirements204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsFinanceRequirements505Schema = z.any();

export const optionsFinanceRequirementsMutationResponseSchema = z.lazy(() => optionsFinanceRequirements204Schema);
